// extracted by mini-css-extract-plugin
export var standaloneTable = "_1n-0";
export var standaloneTableWithBodyFill = "_1n-1";
export var withExtraHeader = "_1n-2";